import { _t } from '@/i18n/t';

const IMAGE_PLACEHOLDER_REGEX = /\[\[(GALLERY_IMAGE|IMAGE):\s*([\s\S]*?)\s*\]\]/gi;
const IMAGE_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>`;
const GALLERY_IMAGE_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 22H4a2 2 0 0 1-2-2V6"/><path d="m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18"/><circle cx="12" cy="8" r="2"/><rect width="16" height="16" x="6" y="2" rx="2"/></svg>`;

function buildImageSuggestionPanel(isGallery: boolean): string {
  const icon = isGallery ? GALLERY_IMAGE_ICON_SVG : IMAGE_ICON_SVG;
  const tooltip = _t('content.output.imagePlaceholderTooltip');

  return `</p><div class="image-suggestion-panel" data-image-source="${isGallery ? 'gallery' : 'stock'}" title="${tooltip}">
  <span class="image-suggestion-icon">${icon}</span>
  <span class="image-suggestion-label"><span class="image-suggestion-label-lead">${_t('content.output.imagePlaceholderLead')}</span> ${_t('content.output.imagePlaceholderBody')}</span>
</div><p>`;
}

export function processImageSuggestions(htmlContent: string): string {
  if (!htmlContent) return htmlContent;

  if (!htmlContent.includes('[[IMAGE:') && !htmlContent.includes('[[GALLERY_IMAGE:')) return htmlContent;

  IMAGE_PLACEHOLDER_REGEX.lastIndex = 0;

  const processed = htmlContent.replace(
    IMAGE_PLACEHOLDER_REGEX,
    (_match, tagType) => buildImageSuggestionPanel(tagType.toUpperCase() === 'GALLERY_IMAGE'),
  );

  return processed.replace(/<p>\s*<\/p>/gi, '');
}
